import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { useIoContext } from '~/contexts';
import LoomPlayer from './LoomPlayer/LoomPlayer';
import styles from './VideoPlayer.module.scss';
import { extractReactPlayerVideoName, getVideoSource, sanitizeUrl, videoPlayerBorderRadius, VideoSource } from './VideoPlayer.utils';
const borderedVideoStyle = {
    borderRadius: videoPlayerBorderRadius,
    overflow: 'hidden'
};
const vimeoConfigs = {
    style: {
        backgroundColor: 'black'
    },
    vimeo: {
        playerOptions: {
            playsinline: 1
        }
    }
};
export var VideoPlayerStatus = /*#__PURE__*/ function(VideoPlayerStatus) {
    VideoPlayerStatus["SUCCESS"] = "success";
    VideoPlayerStatus["NOT_FOUND"] = "not_found";
    VideoPlayerStatus["ACCESS_DENIED"] = "access_denied";
    return VideoPlayerStatus;
}({});
export const VideoPlayerErrors = {
    ["not_found"]: 'was not found',
    ["access_denied"]: 'is not embeddable'
};
export const isStatusSuccess = (status)=>status === "success";
const VideoPlayer = (props)=>{
    const { onError: handleError, onReady, height, width = '100%', roundedCorners = true } = props;
    const { ReactPlayer } = useIoContext();
    const videoSource = useMemo(()=>getVideoSource(new URL(props.url)), [
        props.url
    ]);
    const url = useMemo(()=>sanitizeUrl(props.url, videoSource), [
        props.url,
        videoSource
    ]);
    const isVimeo = videoSource === VideoSource.Vimeo;
    const onError = (e)=>{
        if (!e) return undefined;
        const errorMessage = e.message.toLowerCase();
        handleError === null || handleError === void 0 ? void 0 : handleError((()=>{
            if (errorMessage.includes(VideoPlayerErrors["not_found"])) {
                return "not_found";
            } else if (errorMessage.includes(VideoPlayerErrors["access_denied"])) {
                return "access_denied";
            } else {
                return "success";
            }
        })());
    };
    const onVideoPlayerReady = (reactPlayer)=>{
        const videoName = extractReactPlayerVideoName(url, reactPlayer);
        onReady === null || onReady === void 0 ? void 0 : onReady({
            videoName
        });
    };
    return videoSource === VideoSource.Loom ? /*#__PURE__*/ _jsx(LoomPlayer, {
        url: url,
        onReady: onReady,
        onError: onError,
        roundedCorners: roundedCorners,
        width: width,
        height: height
    }) : /*#__PURE__*/ _jsx(ReactPlayer, {
        controls: true,
        height: height,
        width: width,
        url: url,
        onError: (e)=>{
            if (e && e.message && e.message === VideoPlayerErrors["access_denied"]) {
                onError(e);
            } else {
                onError({
                    message: VideoPlayerErrors["not_found"]
                });
            }
        },
        // https://github.com/cookpete/react-player/issues/1396#issuecomment-1072876117
        disableDeferredLoading: true,
        config: {
            vimeo: {
                playerOptions: vimeoConfigs.vimeo
            }
        },
        onReady: onVideoPlayerReady,
        style: _object_spread({}, roundedCorners ? borderedVideoStyle : {}, isVimeo ? vimeoConfigs.style : {}),
        className: cn(isVimeo && styles.reactPlayerVimeoFlickerFix)
    });
};
export default VideoPlayer;
